const parseDetailForPayment = (purchase) => {
  if (!purchase?.detailForPayment) return null;
  if (typeof purchase.detailForPayment === "string") {
    try {
      return JSON.parse(purchase.detailForPayment);
    } catch {
      return null;
    }
  }
  return purchase.detailForPayment;
};

export const getPaymentTerm = (purchase) => {
  if (purchase?.paymentTerm === "credit" || purchase?.paymentMethod === "crédito") {
    return "credit";
  }
  return "immediate";
};

export const getPurchaseBalance = (purchase) => {
  if (purchase?.balance !== undefined) {
    return Number(purchase.balance || 0);
  }
  const total = Number(purchase?.totalAmount || 0);
  let paidAmount = Number(purchase?.paidAmount || 0);
  if (paidAmount <= 0 && purchase?.isPaid) {
    paidAmount = total;
  }
  return Math.max(total - paidAmount, 0);
};

export const getCreditDueDate = (purchase) => {
  const detail = parseDetailForPayment(purchase);
  const value = purchase?.creditDueDate || detail?.creditDueDate || detail?.creditExpiration;
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const isPurchaseOverdue = (purchase) => {
  if (getPaymentTerm(purchase) !== "credit") return false;
  const balance = getPurchaseBalance(purchase);
  if (balance <= 0) return false;
  const dueDate = getCreditDueDate(purchase);
  return Boolean(dueDate && dueDate < new Date());
};
